module.exports = __webpack_public_path__ + "img/Plus-icon.9e9f4563.svg";